import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../lib/const';
import { getAxiosConfig } from '../../lib/auth';

export const fetchUsers = (search, params = {}) => axios
  .get(`${API_URL}/users`, {
    ...getAxiosConfig(),
    params: { search, page_size: 100, ...params },
  })
  .then(response => response.data)
  .catch((e) => {
    toast.error('Ocorreu um erro inesperado, tente novamente mais tarde');
    return Promise.reject(e);
  });

export const fetchCurrentUser = () => axios
  .get(`${API_URL}/users/me`, getAxiosConfig())
  .then(response => response.data);
